import React from 'react';
import { inject } from 'mobx-react';
import Typography from '@material-ui/core/Typography';
// import config from '../config';
import uiConfig from '../uiConfig';
import { getFullPriceString, parseSummary } from '../utils';
import ShowMoreText from "react-show-more-text";

const RecordingDetails = ({ portal, recording, spoilerDetails = false }) => {
  const { speakers, summary, ceHours, goals, ceTypeName, alias, price, priceForMembers } = recording;
  const speakersString = speakers && speakers.map((speaker) => speaker.firstName + " " + speaker.lastName).join(", ");
  return (
    <>
      {!alias && <Typography variant="body1" gutterBottom><strong>{getFullPriceString(price, priceForMembers)}</strong></Typography>}
      {(portal.hasCertification && (ceHours || ceTypeName)) &&
        <Typography variant="subtitle1" gutterBottom>
          {ceHours ? `${ceHours} Hours ${ceTypeName || ""} Credit(s)` : "No " + uiConfig.certTitle}
        </Typography>
      }
      {speakersString &&
        <Typography variant="body1" gutterBottom>
          <strong>Speakers:</strong> {speakersString}
        </Typography>
      }
      {summary &&
        <>
          {spoilerDetails ?
            <ShowMoreText
              lines={3}
              more="show more"
              className="show-more-button-content"
              less="show less"
              anchorClass="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary MuiTypography-body2 show-more-button"
              expanded={false}
              truncatedEndingComponent={"... "}
            >
              <Typography dangerouslySetInnerHTML={{ __html: parseSummary(summary) }} gutterBottom component="span" style={{ marginTop: 0 }} />
            </ShowMoreText> :
            <Typography dangerouslySetInnerHTML={{ __html: parseSummary(summary) }} gutterBottom component="span" />
          }
        </>}
      {goals &&
        <Typography>
          <b>Learning Goals & Objectives:</b>
          <br />
          {goals}
        </Typography>
      }
    </>
  );
}

export default inject(({ store }, props) => ({
  portal: store.portal, user: store.currentUser,
}))(RecordingDetails);
